import { FormConditionalService } from '@client/services/FormConditionalService';
import { FormParameterValues } from '@client/hooks/useFormParameters';

/**
 * Cleans form data by removing values for questions that are not visible
 * based on conditional logic. This ensures hidden fields are not stored in the database.
 */
export function cleanFormDataForHiddenQuestions(
  formData: PolicyFormSubmissionData,
  formDefinition: PolicyFormDefinition,
  parameters: FormParameterValues = {},
): PolicyFormSubmissionData {
  // Create conditional service to evaluate visibility
  const conditionalService = new FormConditionalService(formDefinition, formData, parameters);
  
  // Get all visible questions
  const { visibleQuestions } = conditionalService.getFormValidationState();
  
  // Collect all compositeFieldRefs to preserve them even if they're not visible questions
  const compositeFieldRefs = new Set<string>();
  Object.values(formDefinition.questions).forEach(question => {
    if (question.composite?.compositeFieldRef) {
      compositeFieldRefs.add(question.composite.compositeFieldRef);
    }
  });

  // Filter form data to only include visible questions and composite field refs
  const cleanedData: PolicyFormSubmissionData = {};

  for (const [questionRef, value] of Object.entries(formData)) {
    if (visibleQuestions.has(questionRef) || compositeFieldRefs.has(questionRef)) {
      cleanedData[questionRef] = value;
    }
  }

  return cleanedData;
}

